// extracted by mini-css-extract-plugin
export default {"buttonStyle":"TextButton_buttonStyle__o-bER"};